<template>
  <form v-on:submit="create" method="post">
    <div class="row">
      <div class="col-xl-4 col-sm-4 col-md-4 col-sm-12 col-12">
        <LabelRequiredField label="Tipo de cobrança" />
        <select v-model="service_charge_type_id" class="form-control">
          <option value>SELECIONE...</option>
          <option
            v-for="value in serviceChargeTypes"
            :key="value.id"
            :value="value.id"
          >
            {{ String(value.name).toUpperCase() }}
          </option>
        </select>
      </div>
      <div class="col-xl-8 col-sm-8 col-md-8 col-sm-12 col-12">
        <LabelRequiredField label="Descrição" />
        <input
          type="text"
          ref="autofocus"
          v-model="description"
          class="form-control"
        />
      </div>
      <div class="col-xl-4 col-sm-4 col-md-4 col-sm-4 col-12">
        <LabelRequiredField label="Custo do serviço" />
        <input
          type="text"
          v-model="service_cost"
          class="form-control"
          v-on:keyup="handleValueServiceCost"
        />
      </div>
      <div class="col-xl-4 col-sm-4 col-md-4 col-sm-4 col-12">
        <label>Lucro(%)</label>
        <input
          type="text"
          v-on:keyup="handleValueProfit"
          v-model="profit"
          class="form-control"
        />
      </div>
      <div class="col-xl-4 col-sm-4 col-md-4 col-sm-4 col-12">
        <LabelRequiredField label="Valor da venda" />
        <input
          type="text"
          v-model="sale_price"
          class="form-control"
          v-on:keyup="handleValueSalePrice"
        />
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <WarningRequiredFields />
        <ErrorsMessages :errors="errors" />
      </div>
      <div class="col-md-12 text-right">
        <v-btn :disabled="loading" type="submit" class="btn-save">
          <i class="fas fa-save mr-2 text-twenty"></i>
          {{ loading ? "Carregando" : "SALVAR" }}
        </v-btn>
      </div>
    </div>
  </form>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";
import LabelRequiredField from "../Components/LabelRequiredField";
import WarningRequiredFields from "../Components/WarningRequiredFields";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import {
  formatDate,
  formatPrice,
  formatValueOnKeyUp,
  formatValueToOnlyNumber,
  formatValueToPercentage,
} from "../../lib/format";

export default {
  name: "Create",

  components: {
    ErrorsMessages,
    LabelRequiredField,
    WarningRequiredFields,
  },

  props: {
    serviceChargeTypes: { type: Array },
  },

  data() {
    return {
      service_charge_type_id: "",
      description: "",
      service_cost: "",
      profit: "",
      sale_price: "",
      loading: false,
      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDate,
    formatPrice,
    formatValueOnKeyUp,
    formatValueToOnlyNumber,
    formatValueToPercentage,

    handleValueProfit: function (e) {
      let profit = formatValueToPercentage(e.target.value);
      if (profit) {
        let current = formatValueToOnlyNumber(this.service_cost);
        let percentage = profit * current;
        let sale_price = percentage / 100;
        sale_price = parseFloat(sale_price) + parseFloat(current);
        this.sale_price = formatPrice(sale_price);
      } else {
        this.sale_price = formatPrice(0);
      }
    },

    handleValueServiceCost: function (e) {
      this.service_cost = formatValueOnKeyUp(e.target.value);

      let { profit, service_cost } = this;
      if (profit) {
        let current = formatValueToOnlyNumber(service_cost);
        let percentage = profit * current;
        let sale_price = percentage / 100;
        sale_price = parseFloat(sale_price) + parseFloat(current);
        this.sale_price = formatPrice(sale_price);
      } else {
        this.sale_price = formatPrice(0);
      }
    },

    handleValueSalePrice: function (e) {
      let sale_price = formatValueToOnlyNumber(e.target.value);

      this.sale_price = formatValueOnKeyUp(sale_price);

      let { service_cost } = this;

      service_cost = formatValueToOnlyNumber(service_cost);

      if (parseFloat(sale_price) > parseFloat(service_cost)) {
        let profit = parseFloat(sale_price) - parseFloat(service_cost);
        profit = parseFloat(profit) / parseFloat(service_cost);
        profit = parseFloat(profit) * 100;
        if (String(profit).indexOf(".") > -1) {
          profit = profit.toFixed(2);
        }
        this.profit = profit;
      } else {
        this.profit = 0;
      }
    },

    async retrieve() {
      this.service_charge_type_id = "";
      this.description = "";
      this.service_cost = "";
      this.profit = "";
      this.sale_price = "";
      this.errors = [];
      setTimeout(() => this.$refs.autofocus.focus(), 10);
    },

    async create(event) {
      try {
        event.preventDefault();

        this.loading = true;

        const {
          service_charge_type_id,
          description,
          service_cost,
          profit,
          sale_price,
        } = this;

        let params = {
          service_charge_type_id,
          description,
          service_cost,
          profit,
          sale_price,
        };

        const response = await api.post("/rest-home/service/create", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("create");
          toast(message, "success");
          this.$emit("success");
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>